import dayjs from 'dayjs';

export const DefaultDateFormat = 'DD.MM.YYYY';
export const ServerDateFormat = 'YYYY-MM-DD';

export const prepareDate = (date: string) => {
  try {
    const [day, month, year] = date?.split('.') ?? [];

    return dayjs(
      new Date(Number(year) ?? 0, Number(month) - 1 ?? 0, Number(day) ?? 0).toISOString(),
    ).format(ServerDateFormat);
  } catch (error) {
    return '';
  }
};

export const prepareDayjs = (date: string | undefined) => {
  const [day, month, year] = date?.split('.') ?? [];

  return dayjs(
    new Date(Number(year) ?? 0, Number(month) - 1 ?? 0, Number(day) ?? 0).toISOString(),
  );
};

/**
 * Пустую дату показываем прочерком, а не строкой `Invalid Date`.
 *
 * Строку `ДД.ММ.ГГГГ` разбираем явно: dayjs читает её как `ГГГГ-ДД-ММ` и молча
 * меняет местами день с месяцем (01.09.2025 превращалось в 9 января).
 * Всё, что распарсить не удалось (например «01.2024» — месяц и год), отдаём как есть:
 * это данные документа, и прятать их за прочерком нельзя.
 */
export const formatDate = (value: unknown, format = DefaultDateFormat) => {
  if (value === null || value === undefined || value === '') return '—';

  const raw = String(value);
  const ruDate = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(raw);

  if (ruDate) {
    const [, day, month, year] = ruDate;
    const parsed = dayjs(`${year}-${month}-${day}`);
    return parsed.isValid() ? parsed.format(format) : raw;
  }

  const date = dayjs(raw);

  return date.isValid() ? date.format(format) : raw;
};
